export default "__VITE_ASSET__ce5026c8__"